export default __webpack_public_path__ + "static/media/mapLao.6cf2d62a.png";